module.exports = __webpack_public_path__ + "static/media/instagram.a88ebec3.png";